import React, { useState, useEffect } from 'react'
import {
  Modal,
  List,
  Checkbox,
  Button,
  Input,
  Alert,
  Tooltip,
  message
} from 'antd'
import { useTranslation } from 'react-i18next'
import { api } from '../../../../../services'

const BulkActionConfirmModal = ({
  visible,
  items = [],
  actionLabel = 'Confirm',
  apiAction = '',
  onSuccess,
  onCancel,
  requireTerms = false,
  disclaimer = '',
  message: infoMessage = ''
}) => {
  const [checkedIds, setCheckedIds] = useState([])
  const [checkedTerms, setCheckedTerms] = useState(false)
  const [loading, setLoading] = useState(false)

  const { t } = useTranslation()

  useEffect(() => {
    if (visible) {
      setCheckedIds(items.map(item => item.id))
      setCheckedTerms(false)
      setLoading(false)
    }
  }, [visible, items])

  const handleCheck = (id, checked) => {
    setCheckedIds(prev =>
      checked ? [...prev, id] : prev.filter(i => i !== id)
    )
  }

  const canConfirm = checkedIds.length > 0 && (!requireTerms || checkedTerms)

  const handleConfirm = async () => {
    setLoading(true)
    try {
      await api.library.updateLibraryStatus({
        action: apiAction,
        library: checkedIds
      })
      message.success(
        apiAction === 'PUBLIC'
          ? t('v5:make_public_success')
          : apiAction === 'ORG'
          ? t('v5:make_org_success')
          : t('v5:make_private_success')
      )
      setLoading(false)
      onSuccess && onSuccess(checkedIds)
    } catch (error) {
      message.error(
        apiAction === 'PUBLIC'
          ? t('v5:make_public_failed')
          : apiAction === 'ORG'
          ? t('v5:make_org_failed')
          : t('v5:make_private_failed')
      )
      setLoading(false)
    }
  }

  return (
    <Modal
      visible={visible}
      title={`Select items to ${actionLabel.toLowerCase()}`}
      onOk={handleConfirm}
      onCancel={onCancel}
      okButtonProps={{ disabled: !canConfirm, loading }}
      footer={[
        <Button key="back" onClick={onCancel} disabled={loading}>
          {t('buttons:no') || t('v4:cancel')}
        </Button>,
        <Button
          key="submit"
          type="primary"
          disabled={!canConfirm}
          loading={loading}
          onClick={handleConfirm}
        >
          {actionLabel}
        </Button>
      ]}
    >
      {infoMessage && (
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message={infoMessage}
        />
      )}
      <List
        dataSource={items}
        renderItem={item => (
          <List.Item>
            <Checkbox
              checked={checkedIds.includes(item.id)}
              onChange={e => handleCheck(item.id, e.target.checked)}
              disabled={loading}
            >
              <Tooltip title={item.title || item.name || `Item ${item.id}`}>
                <span
                  className="bulk-modal-filename"
                  style={{
                    wordBreak: 'break-all',
                    maxWidth: 350,
                    display: 'inline-block',
                    verticalAlign: 'middle'
                  }}
                >
                  {item.title || item.name || `Item ${item.id}`}
                </span>
              </Tooltip>
            </Checkbox>
          </List.Item>
        )}
      />
      {requireTerms && (
        <div style={{ marginTop: 24 }}>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>Disclaimer</div>
          <Input.TextArea
            disabled
            rows={5}
            style={{ resize: 'none', marginBottom: 8 }}
            value={t('media:disclaimer')}
          />
          <Checkbox
            checked={checkedTerms}
            onChange={e => setCheckedTerms(e.target.checked)}
            disabled={loading}
          >
            {t('v5:i_agree_to_the_terms_and_conditions')}
          </Checkbox>
        </div>
      )}
    </Modal>
  )
}

export default BulkActionConfirmModal
